import { useState, useEffect } from 'react';
import axios from 'axios';
import { MapPin, Phone, Globe, Car, Bed, Coffee, WhatsappLogo, Envelope, User } from '@phosphor-icons/react';

const API = '/api';

const defaultHotels = [
  {
    name: 'Hyatt Centric San Salvador',
    category: 'Luxury Hotel',
    description: 'A modern luxury hotel in the heart of San Salvador. Centrally located with easy access to restaurants, shopping, and nightlife. Features elegant rooms, a rooftop pool, fitness center, and on-site dining.',
    description_es: 'Un moderno hotel de lujo en el corazón de San Salvador. Ubicación céntrica con fácil acceso a restaurantes, tiendas y vida nocturna. Cuenta con habitaciones elegantes, piscina en la azotea, gimnasio y restaurante.',
    priceRange: '$$$',
    amenities: ['Rooftop Pool', 'Fitness Center', 'Restaurant', 'WiFi', 'Central Location'],
    distance: 'San Salvador',
    website: null,
    phone: null,
    blockCode: null,
    blockCodeComingSoon: true,
    recommended: false,
    isVenue: false,
    image: 'https://images.unsplash.com/photo-1768913439851-a0097ab6c9f6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHwyfHxIeWF0dCUyMENlbnRyaWMlMjBsdXh1cnklMjBob3RlbCUyMG1vZGVybnxlbnwwfHx8fDE3NzkxNjg2NzJ8MA&ixlib=rb-4.1.0&q=85',
  },
  {
    name: 'Cardedeu Suites',
    category: 'Boutique Hotel',
    description: 'A stylish boutique hotel located in the Zona Rosa district of San Salvador. Steps away from the best restaurants, bars, and nightlife. Elegant suites with modern amenities in one of the city\'s most vibrant neighborhoods.',
    description_es: 'Un elegante hotel boutique ubicado en el distrito de Zona Rosa en San Salvador. A pasos de los mejores restaurantes, bares y vida nocturna. Suites elegantes con amenidades modernas en uno de los vecindarios más vibrantes de la ciudad.',
    priceRange: '$$$',
    amenities: ['Lake Views', 'Restaurant', 'Pool', 'WiFi'],
    distance: 'Zona Rosa, San Salvador',
    website: null,
    phone: null,
    blockCode: null,
    blockCodeComingSoon: true,
    recommended: false,
    isVenue: false,
    image: 'https://images.unsplash.com/photo-1588861424526-28303cffbdd4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBib3V0aXF1ZSUyMGhvdGVsJTIwc3VpdGUlMjBlbGVnYW50JTIwY2l0eSUyMHVyYmFufGVufDB8fHx8MTc3OTE2OTU2OXww&ixlib=rb-4.1.0&q=85',
  },
  {
    name: 'Cardedeu Express',
    category: 'Convenient & Comfortable',
    description: 'A comfortable and convenient option near the wedding venue at Lake Coatepeque. Great value with easy access to the celebration.',
    description_es: 'Una opción cómoda y conveniente cerca del lugar de la boda en el Lago de Coatepeque. Gran valor con fácil acceso a la celebración.',
    priceRange: '$$',
    amenities: ['Lake Views', 'WiFi', 'Parking'],
    distance: 'Near Venue',
    website: null,
    phone: null,
    blockCode: null,
    blockCodeComingSoon: true,
    recommended: false,
    isVenue: false,
    image: 'https://images.unsplash.com/photo-1711059985570-4c32ed12a12c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHwyfHxjb21mb3J0YWJsZSUyMGhvdGVsJTIwZXhwcmVzcyUyMG1vZGVybiUyMHJvb218ZW58MHx8fHwxNzc5MTY4Njc0fDA&ixlib=rb-4.1.0&q=85',
  },
  {
    name: 'Airbnb / Vacation Rentals',
    category: 'Group Option',
    description: 'Group up with friends or family and rent a vacation home! This is a great option for larger groups who want to stay together and share costs. We\'ve curated a list of our favorite listings.',
    description_es: '¡Agrúpate con amigos o familia y renta una casa vacacional! Esta es una excelente opción para grupos grandes que quieren quedarse juntos y compartir costos. Hemos seleccionado una lista de nuestros alojamientos favoritos.',
    priceRange: '$-$$$',
    amenities: ['Full Kitchen', 'Multiple Bedrooms', 'Living Space', 'Privacy'],
    distance: 'Varies',
    website: 'https://www.airbnb.com/wishlists/invite/34c1172a-52fa-436d-b4ee-7f69fa9a3f81?s=67&unique_share_id=arya-wedding-site',
    phone: null,
    blockCode: null,
    recommended: false,
    isVenue: false,
    isAirbnb: true,
    image: 'https://images.unsplash.com/photo-1564013799919-ab600027ffc6?crop=entropy&cs=srgb&fm=jpg&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&ixlib=rb-4.0.3&q=85&w=1200',
  },
];

const transportationInfo = [
  {
    icon: <Car size={24} weight="light" />,
    title: 'Shuttle Service',
    description: 'Complimentary shuttles will run between hotels and the wedding venue throughout the event weekend.',
  },
  {
    icon: <Car size={24} weight="light" />,
    title: 'Car Rental',
    description: 'Rental cars are available at the airport. We recommend booking in advance, especially during peak season.',
  },
  {
    icon: <Car size={24} weight="light" />,
    title: 'Private Transfers',
    description: 'We can arrange private airport transfers. Contact us for recommendations and pricing.',
  },
];

const defaultContent = {
  intro: "We recommend that guests stay in San Salvador, where there are more hotel options, restaurants, cafés, and things to do throughout the weekend. We will provide transportation from San Salvador to the wedding venue and back on the wedding day.",
  intro_es: "Recomendamos que los invitados se hospeden en San Salvador, donde hay más opciones de hoteles, restaurantes, cafés y actividades durante el fin de semana. Proporcionaremos transporte desde San Salvador al lugar de la boda y de regreso el día de la boda."
};

export default function AccommodationsPage() {
  const [content, setContent] = useState(defaultContent);
  const [hotels, setHotels] = useState(defaultHotels);

  useEffect(() => {
    const fetchContent = async () => {
      try {
        const response = await axios.get(`${API}/content/accommodations`);
        if (response.data) {
          setContent(prev => ({ ...prev, ...response.data }));
          // Merge DB hotel data into hardcoded defaults, respecting DB order
          if (response.data.hotels && Array.isArray(response.data.hotels)) {
            const dbHotels = response.data.hotels;
            // Use DB hotels as the source of truth, fall back to defaults only for missing properties
            const merged = dbHotels.map(dbHotel => {
              const defaultHotel = defaultHotels.find(h => h.name === dbHotel.name);
              return {
                ...(defaultHotel || {}),
                ...dbHotel,
                // Map snake_case DB fields to camelCase used by the component
                priceRange: dbHotel.price_range || dbHotel.priceRange || (defaultHotel?.priceRange) || '',
                blockCode: dbHotel.block_code || dbHotel.blockCode || (defaultHotel?.blockCode) || null,
                blockCodeComingSoon: dbHotel.block_code_coming_soon || dbHotel.blockCodeComingSoon || (defaultHotel?.blockCodeComingSoon) || false,
                amenities: dbHotel.amenities || (defaultHotel?.amenities) || [],
                image: dbHotel.image || dbHotel.image_url || (defaultHotel?.image) || '',
                image_position: dbHotel.image_position || (defaultHotel?.image_position) || '50% 50%',
                pdf_url: dbHotel.pdf_url || (defaultHotel?.pdf_url) || '',
                pdf_label: dbHotel.pdf_label || (defaultHotel?.pdf_label) || '',
              };
            });
            // Append any defaults not in DB
            defaultHotels.forEach(dh => {
              if (!merged.find(m => m.name === dh.name)) merged.push(dh);
            });
            setHotels(merged);
          }
        }
      } catch (error) {
        console.log('Using default accommodations content');
      }
    };
    fetchContent();
  }, []);

  return (
    <div data-testid="accommodations-page" className="min-h-screen bg-stone-50">
      {/* Header */}
      <div className="page-header bg-white border-b border-stone-200">
        <div className="max-w-4xl mx-auto px-4">
          <p className="font-body text-sm tracking-[0.2em] uppercase mb-4" style={{ color: "#B8A88A" }}>
            Where to Stay
          </p>
          <h1 className="page-title">Accommodations</h1>
          <p className="page-subtitle mt-6 max-w-3xl mx-auto">
            {content.intro}
          </p>
          {content.intro_es && (
            <p className="font-body text-sm italic text-stone-400 mt-4 max-w-3xl mx-auto">
              {content.intro_es}
            </p>
          )}
        </div>
      </div>

      {/* Hotels Grid */}
      <section data-testid="hotels-section" className="py-12 md:py-20">
        <div className="max-w-6xl mx-auto px-4">
          <div className="space-y-8">
            {hotels.map((hotel, index) => (
              <div
                key={index}
                data-testid={`hotel-${index}`}
                className={`bg-white border ${hotel.isVenue ? 'border-[#C9B99A] border-2' : 'border-stone-200'} overflow-hidden relative`}
              >
                {/* Saturday Celebration Badge */}
                {hotel.isSaturdayCelebration && (
                  <div className="absolute top-4 right-4 z-10 px-4 py-2 bg-[#B8A88A] text-white font-body text-sm font-medium shadow-lg">
                    Saturday Celebration
                  </div>
                )}
                
                {/* Wedding Venue Badge */}
                {hotel.isVenue && (
                  <div className="absolute top-4 right-4 z-10 px-4 py-2 bg-[#C9B99A] text-white font-body text-sm font-medium shadow-lg">
                    Wedding Venue
                  </div>
                )}
                
                {/* Hotel Image */}
                {hotel.image && (
                  <div className="relative h-64 md:h-80 overflow-hidden">
                    <img
                      src={hotel.image}
                      alt={hotel.name}
                      className="w-full h-full object-cover"
                      style={{ objectPosition: hotel.image_position || '50% 50%' }}
                    />
                  </div>
                )}
                
                <div className="p-6 md:p-8">
                  <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-6">
                    <div className="flex-1">
                      <div className="flex items-center gap-3 mb-2">
                        <h3 className="font-display text-2xl text-stone-900">
                          {hotel.name}
                        </h3>
                        <span className="font-body text-sm font-medium" style={{ color: "#B8A88A" }}>
                          {hotel.priceRange}
                        </span>
                      </div>
                      
                      <span className="inline-block font-body text-xs uppercase tracking-wider text-stone-400 mb-4">
                        {hotel.category}
                      </span>
                      
                      <p className="font-body text-stone-600 leading-relaxed mb-6">
                        {hotel.description}
                      </p>

                      {/* Amenities */}
                      <div className="flex flex-wrap gap-2 mb-6">
                        {(hotel.amenities || []).map((amenity, i) => (
                          <span
                            key={i}
                            className="px-3 py-1 bg-stone-100 text-stone-600 font-body text-xs"
                          >
                            {amenity}
                          </span>
                        ))}
                      </div>

                      {/* Block Code */}
                      {hotel.blockCode && (
                        <div className="p-4 bg-[#F5F2ED] border border-[#E8E2D9] mb-6">
                          <p className="font-body text-sm text-stone-700">
                            <strong>Room Block Code:</strong> <span className="text-[#B8A88A] font-semibold">{hotel.blockCode}</span>
                          </p>
                          <p className="font-body text-xs mt-1 text-stone-500">
                            Mention this code when booking for special rates
                          </p>
                          <p className="font-body text-xs italic text-stone-400 mt-1">
                            Menciona este código al reservar para tarifas especiales
                          </p>
                        </div>
                      )}

                      {/* Room Block Coming - Please Wait to Book */}
                      {hotel.blockCodeWaitMessage && (
                        <div className="p-4 bg-red-50 border-2 border-red-300 mb-6">
                          <p className="font-body text-sm text-red-800">
                            <strong>Please Wait to Book!</strong>
                          </p>
                          <p className="font-body text-xs mt-1 text-red-700">
                            Room block information is coming soon for this hotel. Please wait before booking so you can get our special group rate!
                          </p>
                          <p className="font-body text-xs italic text-red-600 mt-1">
                            ¡La información del bloque de habitaciones llegará pronto! Por favor espera antes de reservar para obtener nuestra tarifa especial de grupo.
                          </p>
                        </div>
                      )}

                      {/* Saturday Celebration Notice */}
                      {hotel.isSaturdayCelebration && (
                        <div className="p-4 bg-[#C9B99A]/10 border-2 border-[#C9B99A] mb-6">
                          <p className="font-body text-sm text-stone-800">
                            <strong>Day-After Celebration Venue!</strong>
                          </p>
                          <p className="font-body text-xs mt-1 text-stone-600">
                            The Saturday celebration (day after the wedding) will be held here at Las Palmeras! Stay here to be right where the party continues.
                          </p>
                          <p className="font-body text-xs italic text-stone-500 mt-1">
                            ¡La celebración del sábado (día después de la boda) será aquí en Las Palmeras! Quédate aquí para estar donde continúa la fiesta.
                          </p>
                        </div>
                      )}

                      {/* Hotel Pricing PDF */}
                      {hotel.pdf_url && (
                        <div className="p-4 bg-[#F5F2ED] border border-[#E8E2D9] mb-6">
                          <p className="font-body text-sm text-stone-700 mb-3">
                            <strong>{hotel.pdf_label || 'View Pricing'}</strong>
                          </p>
                          <a
                            href={hotel.pdf_url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="flex items-center justify-center gap-2 w-full px-4 py-3 bg-[#C9B99A] text-white font-body font-medium hover:bg-[#B8A88A] transition-colors"
                          >
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 256 256">
                              <path d="M224,152v56a16,16,0,0,1-16,16H48a16,16,0,0,1-16-16V152a8,8,0,0,1,16,0v56H208V152a8,8,0,0,1,16,0Zm-101.66,5.66a8,8,0,0,0,11.32,0l40-40a8,8,0,0,0-11.32-11.32L136,132.69V40a8,8,0,0,0-16,0v92.69L93.66,106.34a8,8,0,0,0-11.32,11.32Z"></path>
                            </svg>
                            {hotel.pdf_label || 'View Pricing'} (PDF)
                          </a>
                        </div>
                      )}

                      {/* Airbnb Special Section */}
                      {hotel.isAirbnb && (
                        <div className="p-5 bg-gradient-to-r from-[#FF5A5F]/10 to-[#FF5A5F]/5 border-2 border-[#FF5A5F]/30 mb-6 rounded-sm">
                          <p className="font-body text-sm text-stone-700 mb-4">
                            <strong>Group up with friends or family!</strong> Renting a vacation home is a great way to stay together and share costs.
                          </p>
                          <p className="font-body text-xs italic text-stone-500 mb-4">
                            ¡Agrúpate con amigos o familia! Rentar una casa vacacional es una excelente manera de quedarse juntos y compartir costos.
                          </p>
                          <a
                            href={hotel.website}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="flex items-center justify-center gap-2 w-full px-4 py-3 bg-[#FF5A5F] text-white font-body font-medium hover:bg-[#E04E52] transition-colors rounded"
                          >
                            <svg viewBox="0 0 24 24" width="22" height="22" fill="currentColor">
                              <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z"/>
                            </svg>
                            View Our Airbnb Wishlist
                          </a>
                          <p className="font-body text-xs text-center text-stone-400 mt-2">
                            Ver nuestra lista de Airbnb
                          </p>
                        </div>
                      )}

                      {/* Special Contact for Wedding Venue (Cardedeu) */}
                      {hotel.isVenue && hotel.contactPerson && (
                        <div className="p-5 bg-gradient-to-r from-[#FAF8F5] to-[#F5F2ED] border-2 border-[#C9B99A] mb-6 rounded-sm">
                          <div className="flex items-center gap-2 mb-3">
                            <div className="w-8 h-8 bg-[#C9B99A] rounded-full flex items-center justify-center">
                              <User size={16} className="text-white" />
                            </div>
                            <div>
                              <p className="font-display text-lg text-stone-900">{hotel.contactPerson.name}</p>
                              <p className="font-body text-xs text-stone-500">Hotel Reservations Contact</p>
                            </div>
                          </div>
                          
                          <p className="font-body text-sm text-stone-600 mb-4">
                            To book at Cardedeu, please contact {hotel.contactPerson.name} directly via WhatsApp and mention our room block code.
                          </p>
                          <p className="font-body text-xs italic text-stone-400 mb-4">
                            Para reservar en Cardedeu, contacta a {hotel.contactPerson.name} directamente por WhatsApp y menciona nuestro código de bloque.
                          </p>

                          <div className="space-y-2">
                            {/* WhatsApp Button */}
                            <a
                              href={`https://wa.me/${hotel.contactPerson.whatsapp}?text=Hello! I would like to book a room for the Rodriguez-Fernandez wedding (December 11, 2026). Room block code: RODRIGUEZ-FERNANDEZ`}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="flex items-center justify-center gap-2 w-full px-4 py-3 bg-[#25D366] text-white font-body font-medium hover:bg-[#20BD5A] transition-colors rounded"
                            >
                              <WhatsappLogo size={22} weight="fill" />
                              Book via WhatsApp
                            </a>
                            
                            <div className="flex gap-2">
                              <a
                                href={`tel:${hotel.contactPerson.phone}`}
                                className="flex-1 flex items-center justify-center gap-2 px-3 py-2 bg-stone-100 text-stone-700 font-body text-sm hover:bg-stone-200 transition-colors"
                              >
                                <Phone size={16} />
                                {hotel.contactPerson.phone}
                              </a>
                              <a
                                href={`mailto:${hotel.contactPerson.email}`}
                                className="flex-1 flex items-center justify-center gap-2 px-3 py-2 bg-stone-100 text-stone-700 font-body text-sm hover:bg-stone-200 transition-colors"
                              >
                                <Envelope size={16} />
                                Email
                              </a>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>

                    {/* Contact Info */}
                    <div className="md:w-64 space-y-3">
                      <div className="flex items-center gap-2 text-stone-600">
                        <MapPin size={18} className="text-[#B8A88A]" />
                        <span className="font-body text-sm">{hotel.distance}</span>
                      </div>
                      <div className="flex items-center gap-2 text-stone-600">
                        <Phone size={18} className="text-[#B8A88A]" />
                        <span className="font-body text-sm">{hotel.phone}</span>
                      </div>
                      <a
                        href={hotel.website}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex items-center gap-2 text-[#B8A88A] hover:text-[#9A8A6A] transition-colors"
                      >
                        <Globe size={18} />
                        <span className="font-body text-sm underline">Visit Website</span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Transportation */}
      <section data-testid="transportation-section" className="py-16 bg-white border-t border-stone-200">
        <div className="max-w-4xl mx-auto px-4">
          <div className="text-center mb-12">
            <p className="font-body text-sm tracking-[0.2em] uppercase mb-4" style={{ color: "#B8A88A" }}>
              Getting Around
            </p>
            <h2 className="font-display text-2xl md:text-3xl text-stone-900">
              Transportation
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {transportationInfo.map((item, index) => (
              <div key={index} className="p-6 bg-stone-50 border border-stone-200 text-center">
                <div className="inline-flex items-center justify-center w-12 h-12 bg-[#C9B99A] text-white rounded-full mb-4">
                  {item.icon}
                </div>
                <h3 className="font-display text-lg text-stone-900 mb-2">
                  {item.title}
                </h3>
                <p className="font-body text-sm text-stone-600">
                  {item.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
